import { motion } from "framer-motion";
import { DynamicText } from "@tennr/frontend/components/DynamicText";
import "./CaseStudyDetailMetricsSection.css";

interface Metric {
  value: string;
  label: string;
  description: string;
}

interface CaseStudyDetailMetricsSectionProps {
  metrics?: Metric[];
}

const defaultMetrics: Metric[] = [
  {
    value: "87%",
    label: "Reduction in processing time",
    description: "From 5-7 days to under 12 hours",
  },
  {
    value: "3x",
    label: "Increase in referral volume handled",
    description: "Without adding staff",
  },
  {
    value: "$4.2M",
    label: "Annual cost savings",
    description: "In administrative efficiency",
  },
  {
    value: "98%",
    label: "Provider satisfaction score",
    description: "Up from 62% pre-implementation",
  },
];

export const CaseStudyDetailMetricsSection: React.FC<CaseStudyDetailMetricsSectionProps> = ({
  metrics = defaultMetrics,
}) => {
  return (
    <section className="case-study-detail-metrics-section">
      <div className="case-study-detail-metrics-container">
        <motion.h2
          className="case-study-detail-metrics-title"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <DynamicText as="span">Results & Impact</DynamicText>
        </motion.h2>

        <div className="case-study-detail-metrics-grid">
          {metrics.map((metric, index) => (
            <motion.div
              key={index}
              className="case-study-detail-metric-card"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <DynamicText as="span" className="case-study-detail-metric-value">{metric.value}</DynamicText>
              <DynamicText as="h3" className="case-study-detail-metric-label">{metric.label}</DynamicText>
              <DynamicText as="p" className="case-study-detail-metric-description">{metric.description}</DynamicText>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
